import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';

@Pipe({
  name: 'orderByAlphanum'
})
export class OrderByAlphanumPipe implements PipeTransform {

  transform(value: any[], column: any, order: any = "asc"): any {
    if (value == null || column == null) {
      return value;
    }

    let [nonNullEntries, nullEntries] = _.partition(value, (val: any) => {
      return val[column] != null && val[column] !== '';
    });

    if (typeof (value[0][column]) == "string") {
      return _.concat(nonNullEntries.sort((a, b) => {
        const result = _.trimStart(a[column]).localeCompare(_.trimStart(b[column]), 'en', { numeric: true });
        return order == "asc" ? result : -result;
      }), nullEntries);
    }
    else {
      return _.concat(_.orderBy(nonNullEntries, [val => val[column]], order), nullEntries);
    }
  }
}
